import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './FileCategoryEditorV2.html?raw';

import MainCatalogsEditorBaseV2 from '../MainCatalogsEditorBaseV2';
import { MainCatalogs_Classes } from "../../_loadingHelpers/MainCatalogTypes";
import Edit from '../../../moreCore/UI/Edit/Edit';

class FileCategoryEditorV2 extends compose(MainCatalogsEditorBaseV2) {
    templateString: any = template;

    fc_Edit_SPBasePath: MdsLax<InstanceType<typeof Edit>>;

    protected afterSetData(): void {
        super.afterSetData.apply(this, arguments as any);

        this.fc_Edit_SPBasePath.setReadonly(true);
    }

    isValid(): boolean {
        //Need to implement
        return true;
    }

    protected _setEntityClass(): void {
        //You need to set this to Entity class of the editor
        this.entityClass = MainCatalogs_Classes.FileCategory;
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(FileCategoryEditorV2);